import { getPosition } from "../helpers/getPosition";
// import { counter } from "./counter";
import { checkBlogProgress } from "../helpers/blogProgress";

const nav = document.querySelector("#nav");
const scrollToTop = document.querySelector('.scroll-to-top');
const SCROLL_FROM_TOP_VALUE = 10;
const singlePage = document.querySelector('.single');
const pageHeight = singlePage ? singlePage.clientHeight - window.innerHeight: 20;
const progressBar = document.querySelector('.blog-progress');

// COUNTER

const counterSection = document.querySelector(".counter");
const count = document.querySelector(".arena-counter");

function checkCounter(scrollPosition) {
  const counterStarted = +count.innerHTML !== 0;
  const counterPosition = getPosition(counterSection);
  const customScrollPosition = scrollPosition + 250;
  const scrolledToCounter = customScrollPosition >= counterPosition.y;

  if (scrolledToCounter && !counterStarted) {
    counter().start();
  }
}



window.addEventListener("scroll", (e) => {
  const scrollFromTop = window.scrollY;

  checkBlogProgress(scrollFromTop, pageHeight, !!singlePage, progressBar);

  if (count) checkCounter(scrollFromTop);

  if (scrollFromTop <= SCROLL_FROM_TOP_VALUE)
    nav.classList.remove("scrolled");
    if (progressBar) progressBar.classList.remove('show');
    if (scrollToTop) scrollToTop.classList.remove("show")
  if (scrollFromTop > SCROLL_FROM_TOP_VALUE) {
    if (scrollToTop) scrollToTop.classList.add("show");
    if (progressBar) progressBar.classList.add('show');

    const navHasSctolledClass = nav.classList.contains("scrolled");
    if (!navHasSctolledClass) nav.classList.add("scrolled");
  }
});

// TRY TO Throttle Scroll Events LATER !!!!!!!!!!!!
